import type { CategoryWithItemsType } from "@/types/category";
import type { CategoryType } from "@/types/category";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useTranslation } from "react-i18next";

const fetchMainCategories = async (lang: string, companyId?: string) => {
  const url = `https://kaman.rest/api/main-categories?${
    companyId ? `&company_id=${companyId}` : ""
  }`;

  const response = await axios.get(url);
  return response.data.data.categories.map((category: any) => ({
    id: category.id,
    name:
      lang === "ar"
        ? category.name_ar
        : lang === "he"
        ? category.name_he
        : category.name_en,
  }));
};

export function useMainCategories(): ReturnType<
  typeof useQuery<{ id: string; name: string }[]>
>;

export function useMainCategories() {
  const { i18n } = useTranslation();

  return useQuery({
    queryKey: ["main-categories", i18n.language],
    queryFn: () => fetchMainCategories(i18n.language),
  });
}
